//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignEmailStatistics",
  props: {
    statistics: {
      type: Object,
      required: true
    }
  },
  computed: {
    uniqueOpens() {
      var _this$statistics, _this$statistics$open;
      return (_this$statistics = this.statistics) == null ? void 0 : (_this$statistics$open = _this$statistics.open) == null ? void 0 : _this$statistics$open.unique;
    },
    openRate() {
      var _this$statistics2, _this$statistics3, _this$statistics3$ope;
      return (_this$statistics2 = this.statistics) != null && _this$statistics2.open ? `${Math.round(((_this$statistics3 = this.statistics) == null ? void 0 : (_this$statistics3$ope = _this$statistics3.open) == null ? void 0 : _this$statistics3$ope.rate) * 100)}%` : "N/A";
    },
    totalOpens() {
      var _this$statistics4, _this$statistics5, _this$statistics5$ope;
      return (_this$statistics4 = this.statistics) != null && _this$statistics4.open ? (_this$statistics5 = this.statistics) == null ? void 0 : (_this$statistics5$ope = _this$statistics5.open) == null ? void 0 : _this$statistics5$ope.count : "";
    },
    sent() {
      var _this$statistics6, _this$statistics6$sen;
      return (_this$statistics6 = this.statistics) == null ? void 0 : (_this$statistics6$sen = _this$statistics6.send) == null ? void 0 : _this$statistics6$sen.count;
    },
    delivered() {
      var _this$statistics7, _this$statistics7$del;
      return (_this$statistics7 = this.statistics) == null ? void 0 : (_this$statistics7$del = _this$statistics7.delivery) == null ? void 0 : _this$statistics7$del.count;
    },
    clicks() {
      var _this$statistics8, _this$statistics8$cli;
      return (_this$statistics8 = this.statistics) == null ? void 0 : (_this$statistics8$cli = _this$statistics8.click) == null ? void 0 : _this$statistics8$cli.count;
    }
  }
});